import React from 'react';
import { ArrowRight, Lock, Users } from 'lucide-react';
import { BakeryEvent } from '../types/event';
interface EventRowProps {
  event: BakeryEvent;
  onSignup: (event: BakeryEvent) => void;
}
export function EventRow({
  event,
  onSignup
}: EventRowProps) {
  const date = new Date(`${event.date}T12:00:00`);
  const weekday = date.toLocaleDateString('sv-SE', {
    weekday: 'long'
  });
  const shortDate = `${date.getDate()}/${date.getMonth() + 1}`;
  if (event.locked) {
    return <article className="relative overflow-hidden rounded-2xl bg-[#1C1917]" aria-label={event.lockedText ?? 'Kommer snart'} data-id="element-453" data-mp="1krw1wwc36l02">
        <div aria-hidden="true" inert className="grid grid-cols-1 sm:grid-cols-[120px_1fr] gap-x-6 gap-y-3 p-5 md:p-6 blur-[6px] opacity-50 select-none pointer-events-none" data-id="element-454" data-mp="1frhyjrlfjz8d">
          <div className="flex sm:flex-col items-baseline sm:items-start sm:justify-center gap-2 sm:gap-0" data-id="element-455" data-mp="4exl8d4euo5m">
            <span className="text-sm text-[#F5EDE3]/60 capitalize" data-id="element-456" data-mp="3vm1qb2gzw0be">
              {weekday}
            </span>
            <span className="text-3xl md:text-4xl font-extrabold text-[#FFB27A] leading-none tracking-tight" data-id="element-457" data-mp="1ujgmrog3dk1p">
              {shortDate}
            </span>
          </div>
          <div className="min-w-0" data-id="element-458" data-mp="1kmll4woiv3j7">
            {/* Placeholder shapes only – the real event stays secret */}
            <div className="h-7 w-48 rounded-md bg-[#F5EDE3]/70 mb-3" data-id="element-459" data-mp="1pkdhc2w79bt7" />
            <div className="space-y-2" data-id="element-460" data-mp="1bu1kxrsl0qw9">
              <div className="h-3.5 w-full rounded bg-[#F5EDE3]/40" data-id="element-461" data-mp="1bsysvgjiwier" />
              <div className="h-3.5 w-11/12 rounded bg-[#F5EDE3]/40" data-id="element-462" data-mp="1gn30m20m4ugw" />
              <div className="h-3.5 w-2/3 rounded bg-[#F5EDE3]/40" data-id="element-463" data-mp="11xf2f9nqabxe" />
            </div>
            <div className="mt-5 flex sm:justify-end" data-id="element-464" data-mp="16v758ypwvigd">
              <span className="h-10 w-32 rounded-full bg-[#FF7A1A]" data-id="element-465" data-mp="16tm8d2g4jnfc" />
            </div>
          </div>
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center bg-[#0E0C0B]/40" data-id="element-466" data-mp="sybik3gqlshu">
          <span className="w-11 h-11 rounded-full bg-[#0E0C0B] border border-[#FF7A1A]/60 flex items-center justify-center" data-id="element-467" data-mp="2zkpwows4z2ke">
            <Lock className="w-5 h-5 text-[#FF9A4D]" aria-hidden="true" data-id="element-468" data-mp="2usppqkdnf9eb" />
          </span>
          <p className="halloween-display text-2xl md:text-3xl text-[#FF9A4D] tracking-wide leading-tight" data-id="element-469" data-mp="2pvg3tepgxfv8">
            {event.lockedText ?? 'Kommer snart'}
          </p>
        </div>
      </article>;
  }
  return <article className="grid grid-cols-1 sm:grid-cols-[120px_1fr] gap-x-6 gap-y-3 bg-[#1C1917] rounded-2xl p-5 md:p-6" data-id="element-470" data-mp="3iik10xibkpwg">
      <div className="flex sm:flex-col items-baseline sm:items-start sm:justify-center gap-2 sm:gap-0" data-id="element-471" data-mp="3dhwbyhdnij4v">
        <span className="text-sm text-[#F5EDE3]/60 capitalize" data-id="element-472" data-mp="38mz2j9cgm7rg">{weekday}</span>
        <span className="text-3xl md:text-4xl font-extrabold text-[#FFB27A] leading-none tracking-tight" data-id="element-473" data-mp="34iri3od1bdz1">
          {shortDate}
        </span>
      </div>

      <div className="min-w-0" data-id="element-474" data-mp="1t3m962mb8j6z">
        <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 mb-2" data-id="element-475" data-mp="1t3cfa3y59rw0">
          <h3 className="text-xl md:text-2xl font-bold text-[#F5EDE3] leading-tight" data-id="element-476" data-mp="8nef8ru58i8y">
            {event.title}
          </h3>
          {(event.time || event.secondaryTime) && <div className="flex flex-wrap gap-2 shrink-0" data-id="element-477" data-mp="hmjc7tq243j0">
              {event.time && <span className="px-3 py-1 rounded-full bg-[#FF7A1A] text-[#1A0F08] text-sm font-bold whitespace-nowrap" data-id="element-478" data-mp="me1bmdcflw1v">
                  {event.time}
                </span>}
              {event.secondaryTime && <span className="px-3 py-1 rounded-full border border-[#FF7A1A] text-[#FFB27A] text-sm font-bold whitespace-nowrap" data-id="element-479" data-mp="wa4ejlf3xypv">
                  {event.secondaryTime}
                </span>}
            </div>}
        </div>

        <p className="text-[#F5EDE3]/80 leading-relaxed" data-id="element-480" data-mp="324w093cu8r0f">{event.description}</p>

        {event.highlight && <p className="mt-4 rounded-xl bg-[#2A1D14] px-4 py-3 text-[#F5EDE3]/85 leading-relaxed" data-id="element-481" data-mp="372xhrjum8i9s">
            <span className="font-bold text-[#FF9A4D]" data-id="element-482" data-mp="2bsr9s7mm22l3">
              {event.highlight.title}
            </span>{' '}
            – {event.highlight.text}
          </p>}

        {event.dropIn && !event.signup && <div className="mt-5 flex sm:justify-end" data-id="element-483" data-mp="2lqf795blpo6y">
            <span className="inline-flex items-center px-5 py-2.5 rounded-full border border-[#FF7A1A] text-[#FFB27A] text-sm font-bold whitespace-nowrap" data-id="element-484" data-mp="2gswsuzetegrk">
              Drop in
            </span>
          </div>}

        {event.signup && <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-3 sm:justify-end" data-id="element-485" data-mp="1o5j43ol9srij">
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#FFB27A]" data-id="element-486" data-mp="22tnp4z7spf4h">
              <Users className="w-4 h-4" aria-hidden="true" data-id="element-487" data-mp="1y0kt8kfjptl4" />
              Begränsat antal platser
            </span>
            <button onClick={() => onSignup(event)} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#FF7A1A] text-[#1A0F08] text-sm font-bold hover:bg-[#FF9A4D] transition-colors whitespace-nowrap focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FFB27A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#1C1917]" data-id="element-488" data-mp="1aaqetyfkvwyr">
              {event.ctaLabel ?? 'Boka plats'}
              <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-489" data-mp="3c17i30yhgsvx" />
            </button>
          </div>}

        {event.footnote && <p className="mt-5 pt-4 border-t border-[#F5EDE3]/10 text-sm text-[#F5EDE3]/60 leading-relaxed" data-id="element-490" data-mp="3mgsgu1h5jus">
            {event.footnote}
          </p>}
      </div>
    </article>;
}